export default function Logo() {
  return (
    <svg id="logo" viewBox="0 0 2686.12 584.69">
      <path
        className="logoMain"
        d="M645.75,85.1h261.78v32.18h-226.5v152.86h222.17v32.18h-222.17v163.38h226.5v32.18h-261.78V85.1Z"
      />
      <path
        className="logoMain"
        d="M1061.01,366.07l-99.64,131.82h-38.37l118.2-153.48-111.4-145.43h38.37l92.83,123.15,92.21-123.15h38.37l-111.4,145.43,118.2,153.48h-38.37l-99.02-131.82Z"
      />
      <path
        className="logoMain"
        d="M1212.62,471.28l177-243.83h-177v-28.47h218.46v25.99l-178.85,244.45h181.33v28.47h-220.94v-26.61Z"
      />
      <path
        className="logoMain"
        d="M1598.79,191.55c90.97,0,141.1,72.41,141.1,158.43v8.66h-250.02c3.09,64.98,46.41,118.82,116.96,118.82,37.75,0,72.41-14.23,97.78-41.46l16.71,21.04c-29.71,30.94-67.46,48.27-116.96,48.27-87.26,0-149.77-64.98-149.77-157.19,0-86.64,61.27-156.57,144.2-156.57ZM1489.87,333.27h217.22c-.62-50.75-34.04-113.87-108.92-113.87-70.55,0-105.83,61.89-108.3,113.87Z"
      />
      <path
        className="logoMain"
        d="M1759.07,348.12c0-87.26,56.32-156.57,143.58-156.57s144.2,69.31,144.2,156.57-55.7,157.19-144.2,157.19-143.58-69.93-143.58-157.19ZM2012.18,348.12c0-66.22-38.99-127.49-109.54-127.49s-108.92,61.27-108.92,127.49,39.61,128.11,108.92,128.11,109.54-61.27,109.54-128.11Z"
      />
      <path
        className="logoSkyBlue"
        d="M2120.48,497.89V85.1h87.88v412.78h-87.88Z"
      />
      <path
        className="logoSkyBlue"
        d="M2632.27,437.86l30.32,35.28-61.27,50.13-32.8-38.99c-29.09,13.62-62.51,21.04-98.4,21.04-124.39,0-215.37-89.12-215.37-213.51s90.97-213.51,215.37-213.51,215.98,89.12,215.98,213.51c0,58.17-19.8,108.92-53.84,146.05ZM2513.45,419.91l-47.03-55.08,61.27-49.51,47.03,55.08c13.62-21.66,21.04-48.89,21.04-78.6,0-77.36-49.51-135.53-125.63-135.53s-125.01,58.17-125.01,135.53,48.89,135.53,125.01,135.53c15.47,0,30.32-2.48,43.32-7.43Z"
      />
      <path d="M382.09,0c-111.92,0-202.61,90.69-202.61,202.61,0,44.71,14.51,86.01,38.96,119.52l-30.47,35.05-.76-.76c-6.21-6.21-16.27-6.21-22.48,0L4.65,516.5c-6.21,6.21-6.21,16.27,0,22.48l41.06,41.06c6.21,6.21,16.27,6.21,22.48,0l160.08-160.08c6.21-6.21,6.21-16.27,0-22.47l-.79-.79,35.08-30.44c33.51,24.45,74.81,38.96,119.52,38.96,111.92,0,202.61-90.69,202.61-202.61S494.01,0,382.09,0ZM382.09,374.05c-94.65,0-171.44-76.79-171.44-171.44,0-94.65,76.79-171.44,171.44-171.44,94.65,0,171.44,76.79,171.44,171.44,0,94.65-76.79,171.44-171.44,171.44Z" />
      <path
        className="logoRoyalBlue"
        d="M262.44,224.8v71.12c3.79,4.84,7.9,9.51,12.36,13.97,15.53,15.53,33.59,26.98,52.85,34.37v-119.46h-65.21Z"
      />
      <path
        className="logoSkyBlue"
        d="M349.48,175.9v174.91c21.46,4.7,43.75,4.7,65.22,0v-174.91h-65.22Z"
      />
      <path
        className="logoAqua"
        d="M501.73,295.93V126.99h-65.22v217.28c19.26-7.39,37.33-18.84,52.86-34.37,4.46-4.46,8.57-9.12,12.36-13.97Z"
      />
    </svg>
  );
}
